import { useAuth } from "../../contexts/AuthContext";
import { createUserInDatabase } from "../../utils/helper";
import logoGoogle from "../../assets/images/logo-google.png";
import logoFacebook from "../../assets/images/logo-facebook.png";

const SigninWith = ({ withWhat = null }) => {

    const { signInWithGoogle, signInWithFacebook } = useAuth();

    let imgLogo = {
        img: withWhat === "google" ? logoGoogle : logoFacebook,
        alt: `Logo de ${withWhat === "google" ? "logoGoogle" : logoFacebook}`,
    }

    const handleClick = () => {
        switch (withWhat) {
            case "google":
                signInWithGoogle().then(cred => {
                    createUserInDatabase(cred)
                }).catch((error) => console.log(error))
                break;
            case "facebook":
                signInWithFacebook().then(cred => {
                    createUserInDatabase(cred)
                }).catch((error) => console.log(error))
                break;
            default:
                break;
        }
    }

    const element = <>
        <div className="flex justify-center w-28 rounded px-9 py-4 border-2 border-ivory hover:scale-110 cursor-pointer" onClick={handleClick}>
            <img className="h-full w-full" src={imgLogo.img} alt={imgLogo.alt} />
        </div>
    </>

    return (
        <>{element}</>
    )
}

export default SigninWith